/** @module Enums */ /** typedoc */

export enum AppHomePageEnum {
    Dashboard = 'dashboard',
    Distribution = 'releases',
    Mastering = 'library'
}
